// This hook is used to add and delete operation
import { collection, addDoc, doc, deleteDoc, updateDoc } from "firebase/firestore"; 
import { useReducer, useState, useEffect} from "react"
import { db, timestamp } from "../firebase/config"


let initialState={
    document: null,
    isPending: false,
    error: null,
    success: null
}

const firestoreReducer = (state,action) => {
    switch(action.type){
        case 'IS_PENDING':
            return {...state,isPending: true}

        case 'ADDED_DOCUMENT':
            return {isPending: false, document: action.payload, success: true, error: null}
        case 'DELETED_DOCUMENT':
            return {isPending: false, document: null, success: true, error: null}
        case 'UPDATED_DOCUMENT':
            return {isPending: false, document: action.payload, success: true, error: null}
        case 'ERROR':
            return {isPending: false, document: null,success: false, error: action.payload}

        default:
            return state
    }
}
export const useFirestore = (collections) => {
    const[response, dispatch] = useReducer(firestoreReducer, initialState)
    const[isCancelled, setIscancelled] = useState(false)

    //collection ref
    const ref= collection(db, collections)

    //only dispatch if isCancelled is false
    const dispatchIfNotCancelled = (action) => {
        if (!isCancelled) {
            dispatch(action)
        }
    }
    
    //add a document
    const addDocument = async(doc) => {
        dispatch({type: 'IS_PENDING'})
        try {
            doc.createdAt = timestamp
            const addedDocument = await addDoc(ref,doc)
            dispatchIfNotCancelled({type: 'ADDED_DOCUMENT', payload: addedDocument})
        } catch (error) {
            dispatchIfNotCancelled({type: 'ERROR',payload: error.message})
        }
    }

    //delete a document
    const deleteDocument = async(id) => {
        dispatch({type:'IS_PENDING'})
        try {
            const deleteRef = doc(db,collections,id )
            await deleteDoc(deleteRef)
            dispatchIfNotCancelled({type: 'DELETED_DOCUMENT'})
        } catch (error) {
            dispatchIfNotCancelled({type: 'ERROR', payload: 'could not able to delete'})
        }

    }

    //update document
    const updateDocument = async(id,updates) => {
        dispatch({type: 'IS_PENDING'})
        try {
            const updateRef = doc(db, collections, id)
            const updatedDocument = await updateDoc(updateRef, updates)
            dispatchIfNotCancelled({
                type: 'UPDATED_DOCUMENT',
                payload: updatedDocument
            })
            return updatedDocument
        } catch (error) {
            dispatchIfNotCancelled({type:'ERROR', payload: error.message})
            return null
        }
    }
    useEffect(() => {
        return () => setIscancelled(true)
    },[])

    return { addDocument, deleteDocument, updateDocument, response}
}
